<template>
  <div>
    <div v-if="Object.keys(sorters).length > 0" class="sorter-container">
      <div class="selected-sorter" @click="showSorters = !showSorters">{{ selectedSorter.label }}
      <span>
        <img
              :src="require('@/assets/img/coupon-with-cart/arrow-down.svg')"
              alt=""
            />
      </span>
      </div>
      <transition name="fade">
        <ul v-if="showSorters" class="sorters">
          <li v-for="(sorter, i) in sorters" :key="i" @click="clickSortBy(sorter)">
          <span>
            <img
              v-if="selectedSorter.key === sorter.key"
              :src="require('@/assets/img/coupon-with-cart/sorter-checked-icon.svg')"
              alt=""
            />
          </span>
            {{ sorter.label }}
          </li>
        </ul>
      </transition>
    </div>
    <div v-if="showSorters" class="sorter-closer" @click="showSorters = false" />
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import '@/styles/color.css'

export default {
  name: 'CouponWithCartSorter',
  data() {
    return {
      showSorters: false
    }
  },
  computed: {
    ...mapGetters({
      sorters: 'CouponWithCart/sorters',
      selectedSorter: 'CouponWithCart/selectedSorter'
    })
  },
  methods: {
    ...mapActions('CouponWithCart', [
      'selectSorter'
    ]),
    clickSortBy(sorter) {
      this.selectSorter(sorter)
      this.showSorters = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sorter-container {
  position: relative;;
  font-size: 12px;
  color: #311300;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;

  .selected-sorter {
    width: 90%;
    height: 30px;
    border: 1px solid var(--accent-color);
    border-radius: 4px;
    text-align: left;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 16px;
    display: flex;
    justify-content: space-between
  }

  .sorters {
    width: 90%;
    position: absolute;
    top: 32px;
    z-index: 2;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.35);
    list-style: none;
    padding: 14px 26px;

    li {
      margin: 13px 0;
      display: flex;
      align-items: center;

      span {
        width: 14px;
        margin-right: 5px;
      }
    }
  }
}

.sorter-closer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1;
}
</style>
